// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"dF-z","smallCardRow":"eF-z","largeCardRow":"fF-z","productSearchRow":"gF-z","curatedRow":"hF-z"};